import Client from '@twilio/conversations';
import { GlobalChatToken } from '../../services/twilioServices';
import { participantName } from '../../constants/liveStreamHelper';

const emoCodes = ['%heart%', '%like%'];

export const handleTwilioGlobalConv = async (
  userId,
  chatSID,
  participantName,
  setGlobalConversations
) => {
  const token = await GlobalChatToken(userId, chatSID, participantName);
  try {
    const globalConversations = await Client.create(token);
    setGlobalConversations(globalConversations);
  } catch (error) {
    console.log(error, 'error');
  }
};

export const globalChatOperations = (
  globalConversations,
  globalChatSid,
  setRooms
) => {
  globalConversations.on('connectionStateChanged', async (state) => {
    if (state === 'connected') {
    }
  });
  globalConversations.on('conversationJoined', (conversation) => {
    if (conversation.sid === globalChatSid) {
      setRooms((prevState) => {
        return { ...prevState, activeGConversation: conversation };
      });
    }
  });
};

export const updateGlobalMsgFunc = (
  x,
  setShowEmo,
  dispatch,
  updateMessages,
  userId
) => {
  const isEmo = emoCodes.some((emoCode) => emoCode === x.body);
  if (isEmo) {
    return setShowEmo ? setShowEmo({ emoCode: x.body }) : null;
  } else {
    // const seperatorIndex = x.author.indexOf('_') + 1;
    const { name, userId: msgUserId } = participantName(x.author);

    dispatch(
      updateMessages({
        newComment: x.body,
        name: name,
        identity: msgUserId,
        newMsgCount: userId !== msgUserId,
      })
    );
  }
};

const addToParticipantsList = (participantName, reduxFunc, dispatch) => {
  //adding to global participants list
  dispatch(
    reduxFunc({
      identity: participantName,
      listType: 'globalParticipants',
    })
  );
};

const removeFromParticipantsList = (participantName, reduxFunc, dispatch) => {
  //removing from global participants
  dispatch(
    reduxFunc({
      identity: participantName,
      listType: 'globalParticipants',
    })
  );
};

export const listenUpdateNewMsgs = (
  activeGConversation,
  setShowEmo,
  dispatch,
  updateMessages,
  userId,
  updateNameToList,
  removeNameFromList
) => {
  //On new message
  activeGConversation?.on('messageAdded', (x) => {
    updateGlobalMsgFunc(x, setShowEmo, dispatch, updateMessages, userId);
  });

  //On new participant joined
  activeGConversation.on('participantJoined', (p) =>
    addToParticipantsList(p.state.identity, updateNameToList, dispatch)
  );

  //On participant left
  activeGConversation.on('participantLeft', (p) =>
    removeFromParticipantsList(p.state.identity, removeNameFromList, dispatch)
  );
};

export const clearListenUpdateNewMsgs = (activeGConversation) => {
  if (activeGConversation) {
    try {
      activeGConversation?.leave();
    } catch (error) {
      console.log(
        error,
        'error in global chat user removal as doing multiple times'
      );
    }
  }
};

export const globalConvCleanup = (
  globalConversations,
  globalChatSid,
  setRooms
) => {
  globalConversations.removeAllListeners();
  globalConversations.shutdown();
  globalConversations.off('connectionStateChanged', async (state) => {
    if (state === 'connected') {
    }
  });

  globalConversations.off('conversationJoined', (conversation) => {
    if (conversation.sid === globalChatSid) {
      //(conversation, 'This is active global conversation');
      setRooms((prevState) => {
        return { ...prevState, activeGConversation: conversation };
      });
    }
  });

  globalConversations.off('conversationJoined', (conversation) => {
    if (conversation.sid === globalChatSid) {
      //(conversation, 'This is active global conversation');
      setRooms((prevState) => {
        return { ...prevState, activeGConversation: conversation };
      });
    }
  });
};

export const getNewGlobalChatToken = async (
  userId,
  chatSID,
  participantName,
  globalConversations
) => {
  console.log(
    userId,
    chatSID,
    participantName,
    globalConversations,
    'in console'
  );
  const token = await GlobalChatToken(userId, chatSID, participantName);
  try {
    // const globalConversations = await Client.create(token);
    // setGlobalConversations(globalConversations);
    const res = await globalConversations.updateToken(token);
    console.log('updated token for global chat', res);
  } catch (error) {
    console.log(error, 'error');
  }
};
